import React from "react";
import { ImmigrationProgram } from "../types/program";
import {
  ReUkProjReq,
  ReUkPerReq,
  ReUaeInvReq,
  ReUaePerReq,
  ReGreeceInvReq,
  ReGreeceDepReq,
  ReGreecePerReq,
  ReMaltaPolicyChangeNote,
  ReMaltaInvReq,
  ReMaltaPerReq,
  ReMaltaDepReq,
  PaTurkeyPerReq,
  PaTurkeyDepReq,
  PaTurkeyInvReq,
  PaMaltaInvReq,
  PaMaltaPerReq,
  PaMaltaDepReq,
  ReSpainInvReq,
  ReSpainPerReq,
  ReSpainOtherReqPR,
  ReSpainOtherReqCitizenship,
  RePortugalInvReq,
  RePortugalDepReq,
  RePortugalPerReq,
  ReSingaporeInvReq,
  ReSingaporePerReq,
  PaVanuatuPerReq,
  PaVanuatuInvReq,
  PaVanuatuDepReq,
  PaSaintKittsAndNevisInvReq,
  PaSaintKittsAndNevisPerReq,
  PaSaintKittsAndNevisDepReq,
  PaStLuciaReunionReq,
  PaAntiguaAndBarbudaPerReq,
  PaAntiguaAndBarbudaDepReq,
  PaAntiguaAndBarbudaInvReq,
  PaDominicaInvReq,
  PaDominicaPerReq,
  PaGrenadaInvReq,
  PaGrenadaPerReq,
  PaGrenadaDepReq,
  PaStLuciaInvReq,
  PaStLuciaPerReq,
  PaStLuciaDepReq,
  PaGeorgiaInvReq,
  PaGeorgiaPerReq,
  PaGeorgiaDepReq,
  ReJapanInvReq_Individual,
  ReJapanPerReq_Individual,
  ReJapanOtherReq_Individual,
  ReJapanInvReq_Mgt,
  ReJapanPerReq_Mgt,
  ReJapanOtherReq_Mgt,
  PaElSalvadorInvReq,
  PaElSalvadorPerReq,
  PaElSalvadorDepReq,
  PaElSalvadorOtherReq,
  PaNauruInvReq,
  PaNauruPerReq,
  PaNauruDepReq,
  ReCyprusInvReq,
  ReCyprusPerReq,
  ReCyprusDepReq,
  RePanamaInvReq,
  RePanamaPerReq,
  RePanamaDepReq,
  ReUkGTVDepReq,
  ReUkGTVPerReq,
  ReUkGTVProjReq,
  ReUkDepReq,
  ReHungaryProjReq,
  ReHungaryPerReq,
  ReHungaryDepReq,
  PaSaoTomeProjReq,
  PaSaoTomePerReq,
  PaSaoTomeDepReq,
} from "./programRequirements";
import {
  ukImgMap,
  ukImgFlag,
  ukImgBackground,
  uaeImgMap,
  uaeImgFlag,
  uaeImgBackground,
  greeceImgMap,
  greeceImgFlag,
  greeceImgBackground,
  turkeyImgMap,
  turkeyImgFlag,
  turkeyImgBackground,
  maltaImgMap,
  maltaImgFlag,
  maltaImgBackground,
  spainImgMap,
  spainImgFlag,
  spainImgBackground,
  portugalImgMap,
  portugalImgFlag,
  portugalImgBackground,
  singaporeImgMap,
  singaporeImgFlag,
  singaporeImgBackground,
  vanuatuImgMap,
  vanuatuImgFlag,
  vanuatuImgBackground,
  stKittsImgMap,
  stKittsImgFlag,
  stKittsImgBackground,
  stLuciaImgMap,
  stLuciaImgFlag,
  stLuciaImgBackground,
  dominicaImgMap,
  dominicaImgFlag,
  dominicaImgBackground,
  grenadaImgMap,
  grenadaImgFlag,
  grenadaImgBackground,
  antiguaImgMap,
  antiguaImgFlag,
  antiguaImgBackground,
  georgiaImgMap,
  georgiaImgFlag,
  georgiaImgBackground,
  japanImgMap,
  japanImgFlag,
  japanImgBackground,
  nauruImgMap,
  nauruImgFlag,
  nauruImgBackground,
  elSalvadorImgMap,
  elSalvadorImgFlag,
  elSalvadorImgBackground,
  cyprusImgMap,
  cyprusImgFlag,
  cyprusImgBackground,
  panamaImgMap,
  panamaImgFlag,
  panamaImgBackground,
  hungaryImgMap,
  hungaryImgFlag,
  hungaryImgBackground,
  saoTomeImgMap,
  saoTomeImgFlag,
  saoTomeImgBackground,
} from "../assets/imgExport";

const residenceUk: ImmigrationProgram = {
  id: 1,
  image: {
    map: ukImgMap,
    flag: ukImgFlag,
    background: ukImgBackground,
  },
  country: "英国",
  countryEn: "uk-innovator",
  continent: "欧洲",
  description:
    "英国创新者签证要求合理金额英镑，6-12个月获批，3年可申请永居。配偶可工作，子女享免费教育，全家享医疗福利，审批快速，适合移民英国。",
  immigrationType: {
    title: "创新者签证",
    type: "居留项目",
  },
  investmentAmount: {
    set: 0,
    optional: 0,
    above: false,
  },
  currency: {
    title: "英镑",
    symbol: "£",
  },
  countryOverview: {
    description: [
      "大不列颠及北爱尔兰联合王国(英语:The United Kingdom of Great Britain and Northern Ireland)，简称“英国”。",
      "英国是由大不列颠岛上的英格兰、威尔士和苏格兰以及爱尔兰岛东北部的北爱尔兰以及一系列附属岛屿共同组成的一个欧洲⻄部岛国。",
      "英国是一个高度发达的资本主义国家，欧洲四大经济体之一，其国⺠拥有极高的生活水平和良好的社会保障体系。英国是全球最大的金融服务净出口国。 英国作为全球金融中心的地位短时间内仍难撼动。",
    ],
    officialCurrency: "英镑",
    officialLanguage: "英语",
    visaFree: 190,
  },
  advantages: [
    [
      "先获得项目背书再申请签证",
      "申请均需要通过英国内政部指定背书机构(Endorsing Body)进行背书支持，之后递交签证申请降低被拒签⻛险",
    ],
    ["办理周期短", "6-12个月即可获批取得签证"],
    [
      "快速申请英国永居的路径",
      "主申请人3年后可申请永居，是最快能移⺠英国的方式之一",
    ],
    ["灵活安排", "申请人可全职、也可兼职工作"],
    ["全家一起申请", "配偶签证无需工作许可，可合法工作"],
    [
      "子女教育福利",
      "18周岁以下随行子女可免费就读于公立学校，入读私立学校不受签证限制，选择范围与本地学生一致",
    ],
    [
      "全家医疗福利",
      "支付NHS移⺠医疗附加费后，可享受英国公立医疗体系，获得永居后无需支付NHS费用",
    ],
  ],
  requirements: {
    investmentRequirement: null,
    projectRequirement: <ReUkProjReq />,
    personalRequirement: <ReUkPerReq />,
    dependentsRequirement: <ReUkDepReq />,
    otherRequirement: null,
  },
  process: {
    steps: 7,
    duration: {
      min: 6,
      max: 12,
      unit: "个月",
    },
    details: [
      "评估签约",
      "材料收集、申请材料准备",
      "材料翻译、材料整合",
      "递交背书机构、申请背书",
      "面试、拿到背书信",
      "递交移⺠局审批",
      "获得签证",
    ],
  },
};

const residenceUae: ImmigrationProgram = {
  id: 2,
  image: {
    map: uaeImgMap,
    flag: uaeImgFlag,
    background: uaeImgBackground,
  },
  country: "阿联酋",
  countryEn: "uae",
  continent: "中东",
  description:
    "投资200万迪拉姆于迪拜房产，1-3个月获批，无居住限制，收益率高，全家享房产增值和税收优惠。",
  immigrationType: {
    title: "投资移民",
    type: "居留项目",
  },
  investmentAmount: {
    set: 2000000,
    optional: 0,
    above: false,
  },
  currency: {
    title: "迪拉姆",
    symbol: "迪拉姆",
  },
  countryOverview: {
    description: [
      "迪拜是阿拉伯联合酋⻓国人口最多的城市，也是中东地区的经济和金融中心。位于阿拉伯湾东南岸，为该国七个酋⻓国之一迪拜酋⻓国的首府。",
      "作为阿拉伯联合酋⻓国的经济中心，迪拜已经成为全球城市，同时也是世界主要客运及货运枢纽。迪拜采行⻄方商业模式，经济发展主要依赖观光业、航空业、房地产及金融服务业。",
    ],
    officialCurrency: "迪拉姆",
    officialLanguage: "阿拉伯语、英语",
    visaFree: 180,
  },
  advantages: [
    ["⻔槛低", "200万迪拉姆投资迪拜房产，相当于400万人⺠ 币投资⻔槛"],
    ["高收益", "6-8%回报率+房产增值，无投资税，无收入税"],
    [
      "灵活安排",
      "在阿联酋境外居留时间没有限制，在阿联酋工作、学习或⻓期居住，无需担保人",
    ],
    [
      "一步到位",
      "可为父母担保10年，可为子女担保至25岁，还可担保最多2名女佣和1名司机(为期2年)",
    ],
    ["资金安全", "可在阿联酋开设银行账户，期房投资前期资 金投入低"],
  ],
  requirements: {
    investmentRequirement: <ReUaeInvReq />,
    projectRequirement: null,
    personalRequirement: <ReUaePerReq />,
    dependentsRequirement: null,
    otherRequirement: null,
  },
  process: {
    steps: 11,
    duration: {
      min: 1,
      max: 3,
      unit: "个月",
    },
    details: [
      "评估签约",
      "远程/现场考察房产",
      "签署协定协议",
      "⽀付定⾦",
      "签署正式购房合同",
      "收集资料",
      "资料制作",
      "材料递交",
      "获得批复涵",
      "⼊境录指纹",
      "全家获得居民卡",
    ],
  },
};

const residenceGreece: ImmigrationProgram = {
  id: 3,
  image: {
    map: greeceImgMap,
    flag: greeceImgFlag,
    background: greeceImgBackground,
  },
  country: "希腊",
  countryEn: "greece",
  continent: "欧洲",
  description:
    "投资25万欧元购房，6-8个月获批，附带永久居留，畅游27个申根国，房产可出租或自住。",
  immigrationType: {
    title: "投资移⺠",
    type: "居留项目",
  },
  investmentAmount: {
    set: 250000,
    optional: 0,
    above: true,
  },
  currency: {
    title: "欧元",
    symbol: "€",
  },
  countryOverview: {
    description: [
      "希腊共和国，简称希腊(Greece)，是地处欧洲东南⻆、巴尔干半岛的南端的共和制国家。全国由半岛南部的伯罗奔尼撒半岛和爱琴海中的3000余座岛屿构成。",
      "希腊为连接欧亚非的战略要地，本土从⻄北至正北部分别邻阿尔巴尼亚、北⻢其顿、保加利亚三国，东北与土耳其国境接壤。周围自东而⻄分别濒临爱琴海、地中海本域与伊奥尼亚海。",
      "希腊被视为⻄方文明的发源地，历史可上溯到古希腊。",
    ],
    officialCurrency: "欧元",
    officialLanguage: "希腊语",
    visaFree: 186,
  },
  advantages: [
    ["⻔槛低", "25万欧元投资⻔槛，欧洲入⻔级优质项目"],
    ["唯一“房产+绿卡”组合", "欧洲版“买房落户”，房产投资有保障，固定资产⻛险低"],
    ["教育可进可退", "欧美名校一键获取，回国名校轻松入读"],
    ["房产投资性", "世界级投资客众多，希腊房产价格稳步增⻓，出租+自住皆可"],
    ["维持成本低", "低税费，汇率+租金+房产增值"],
    ["100%获批，申请简单", "主申请人年龄要求宽泛，附属申请人100%可加入"],
    ["畅游欧洲，养老度假", "自由通行27个申根国"],
  ],
  requirements: {
    investmentRequirement: <ReGreeceInvReq />,
    projectRequirement: null,
    personalRequirement: <ReGreecePerReq />,
    dependentsRequirement: <ReGreeceDepReq />,
    otherRequirement: null,
  },
  process: {
    steps: 11,
    duration: {
      min: 6,
      max: 8,
      unit: "个月",
    },
    details: [
      "评估签约",
      "远程/现场考察房产",
      "签署协定协议",
      "⽀付定⾦",
      "签署正式购房合同",
      "收集资料",
      "资料制作",
      "材料递交",
      "获得批复涵",
      "⼊境录指纹",
      "全家获得居民卡",
    ],
  },
};

const passportTurkey: ImmigrationProgram = {
  id: 4,
  image: {
    map: turkeyImgMap,
    flag: turkeyImgFlag,
    background: turkeyImgBackground,
  },
  country: "土耳其",
  countryEn: "turkey",
  continent: "欧洲",
  description:
    "投资40万美元购房，6-8个月获护照，无居住要求，可申请美国E-2签证，3年后房产可出售。",
  immigrationType: {
    title: "护照",
    type: "护照项目",
  },
  investmentAmount: {
    set: 400000,
    optional: 0,
    above: false,
  },
  currency: {
    title: "美金",
    symbol: "$",
  },
  countryOverview: {
    description: [
      "土耳其共和国(土耳其语:Türkiye Cumhuriyeti;英语:The Republic of Turkey)地跨亚欧两大洲，政治、经济、文化 等领域均实行欧洲模式，欧盟候选国，1995 年与欧盟订立关税同盟，2005年开始入盟谈 判，目标2023年，建国100周年时加入欧盟。 宪法规定土耳其为⺠主、政教分离、实行法制 之国家，外交重心在⻄方，与美国保持传统战 略伙伴关系，同时强化与欧洲国家关系。",
      "土耳其是经济合作与发展组织(OECD)创始会 员国，二十国集团(G20)成员国，其拥有雄厚 工业基础，世界新兴经济体之一，全球发展最 快国家之一。",
    ],
    officialCurrency: "土耳其里拉",
    officialLanguage: "土耳其语",
    visaFree: 115,
  },
  advantages: [
    ["最高性价比", "投资金额最低的大国公⺠入籍项目之一"],
    ["无居住要求", "拿到护照后无任何居住要求"],
    ["申请要求简单", "无需证明学历、管理经验、资金来源以 及体检"],
    ["房价低且周期短", "土耳其目前房价低谷，投资好时机，3 年后即可卖出"],
    ["美国E-2签证缔约国", "拥有土耳其护照就是拥有申请美国 E-2签证的敲⻔砖"],
  ],
  requirements: {
    investmentRequirement: <PaTurkeyInvReq />,
    projectRequirement: null,
    personalRequirement: <PaTurkeyPerReq />,
    dependentsRequirement: <PaTurkeyDepReq />,
    otherRequirement: null,
  },
  process: {
    steps: 10,
    duration: {
      min: 6,
      max: 8,
      unit: "个月",
    },
    details: [
      "评估签约",
      "选择房源",
      "签署律师授权书",
      "支付所购房款",
      "收集材料",
      "制作材料",
      "材料递交",
      "申请居留许可",
      "获得居留证，申请公民身份",
      "获得护照",
    ],
  },
};

const residenceMalta: ImmigrationProgram = {
  id: 5,
  image: {
    map: maltaImgMap,
    flag: maltaImgFlag,
    background: maltaImgBackground,
  },
  country: "⻢耳他",
  countryEn: "malta",
  continent: "欧洲",
  description:
    "投资80,000欧元起，10-12个月获批，全家四代拿永居，无居住要求，享欧盟与申根福利。",
  immigrationType: {
    title: "投资移⺠",
    type: "居留项目",
  },
  investmentAmount: {
    set: 300000,
    optional: 0,
    above: true,
  },
  currency: {
    title: "欧元",
    symbol: "€",
  },
  countryOverview: {
    description: [
      "⻢耳他共和国(⻢耳他语:Repubblika ta' Malta，英语:(Republic of Malta) 简称⻢耳他，位于南欧的共和制的一个国家，是一个位于地中海中心的岛国，有“地中海心脏”，“欧洲的乡村”之称“。官方语言为⻢耳他语和英语，首都瓦莱塔 (Valletta)。",
      "⻢耳他是一个高度发达的资本主义国家， 经济以服务业和金融业为主，旅游业是⻢耳他主要的外汇来源。⻢耳他社会保障体系较为完备，实行免费教育，免费医疗及退休保险制。",
    ],
    officialCurrency: "欧元",
    officialLanguage: "英语、⻢耳他语",
    visaFree: 187,
  },
  advantages: [
    [
      "拿永居，畅游申根",
      "投资获永居身份，全 球唯一的四位一体 国，即欧盟成员国、 申根国、欧元国、英 联邦国家",
    ],
    ["申请要求简单", "无管理经验、教育背 景、语言要求"],
    ["资金安全", "先批复，后投资"],
    ["一步到位", "全家四代拿欧盟永居"],
    ["移⺠不移居", "无居住要求"],
  ],
  requirements: {
    investmentRequirement: <ReMaltaInvReq />,
    projectRequirement: null,
    personalRequirement: <ReMaltaPerReq />,
    dependentsRequirement: <ReMaltaDepReq />,
    otherRequirement: [<ReMaltaPolicyChangeNote />],
  },
  process: {
    steps: 7,
    duration: {
      min: 10,
      max: 12,
      unit: "个月",
    },
    details: [
      "评估签约",
      "预背调，收集资料",
      "资料制作",
      "材料递交",
      "获得批复涵",
      "登陆马耳他",
      "获得居留身份和永居卡",
    ],
  },
};

const passportMalta: ImmigrationProgram = {
  id: 6,
  image: {
    map: maltaImgMap,
    flag: maltaImgFlag,
    background: maltaImgBackground,
  },
  country: "⻢耳他",
  countryEn: "malta",
  continent: "欧洲",
  description:
    "投资60万欧元起，1.5-3.5年获批护照，全家四代拿欧盟身份，自由通行欧盟及申根国，享最高福利待遇。",
  immigrationType: {
    title: "护照",
    type: "护照项目",
  },
  investmentAmount: {
    set: 600000,
    optional: 750000,
    above: true,
  },
  currency: {
    title: "欧元",
    symbol: "€",
  },
  countryOverview: {
    description: [
      "⻢耳他共和国(⻢耳他语:Repubblika ta' Malta，英语:(Republic of Malta) 简称⻢耳他，位于南欧的共和制的一个国家，是一个位于地中海中心的岛国，有“地中海心脏”，“欧洲的乡村”之称“。官方语言为⻢耳他语和英语，首都瓦莱塔 (Valletta)。",
      "⻢耳他是一个高度发达的资本主义国家， 经济以服务业和金融业为主，旅游业是⻢耳他主要的外汇来源。⻢耳他社会保障体系较为完备，实行免费教育，免费医疗及退休保险制。",
    ],
    officialCurrency: "欧元",
    officialLanguage: "英语、⻢耳他语",
    visaFree: 187,
  },
  advantages: [
    ["顶级身份", "每年全球限量400组投资入籍名额"],
    [
      "欧洲自由居住",
      "可以在欧盟27个国家自由居住、生活和工作，并享受欧盟国家最高福利待遇",
    ],
    ["一步到位", "全家四代拿欧盟永居"],
  ],
  requirements: {
    investmentRequirement: <PaMaltaInvReq />,
    projectRequirement: null,
    personalRequirement: <PaMaltaPerReq />,
    dependentsRequirement: <PaMaltaDepReq />,
    otherRequirement: [<ReSpainOtherReqPR />, <ReSpainOtherReqCitizenship />],
  },
  process: {
    steps: 8,
    duration: {
      min: 1.5,
      max: 3.5,
      unit: "年",
    },
    details: [
      "评估签约",
      "预背调，收集材料",
      "资料制作",
      "材料递交",
      "获得批复涵",
      "登陆马耳他",
      "获得居留身份和永居卡 护照申请",
      "完成宣誓并获得护照",
    ],
  },
};

const residenceSpain: ImmigrationProgram = {
  id: 7,
  image: {
    map: spainImgMap,
    flag: spainImgFlag,
    background: spainImgBackground,
  },
  country: "⻄班牙",
  countryEn: "spain",
  continent: "欧洲",
  description:
    "投资50万欧元购房，6-8个月获批，可自由通行申根国，5年可申请永居，10年后可申请入籍。",
  immigrationType: {
    title: "投资移⺠",
    type: "居留项目",
  },
  investmentAmount: {
    set: 500000,
    optional: 0,
    above: true,
  },
  currency: {
    title: "欧元",
    symbol: "€",
  },
  countryOverview: {
    description: [
      "⻄班牙王国(⻄班牙语:Reino de España)，通称⻄班牙(España)，国土面 积约占伊比利亚半岛的六分之五。其领土还包 括地中海中的巴利阿里群岛、大⻄洋的加那利 群岛、以及在非洲北部的休达、梅利利亚。首 都兼最大城市为⻢德里。",
      "其全球帝国的兴盛使得现今全球有5亿人口使 用⻄班牙语，令⻄班牙语成为世界上总使用人 数第三多、母语人数第二多的语言。",
      "⻄班牙是中等发达国家，拥有较高的社会福 利，人均GDP在三万美元左右。近些年受经 济危机影响在发达国家里失业率偏高。",
    ],
    officialCurrency: "欧元",
    officialLanguage: "西班牙语",
    visaFree: 190,
  },
  advantages: [
    ["申请简单", "无语言，学历的要求，无面试要求"],
    ["一步到位", "一人申请，全家获得身份(配偶、父母和子女可随同移⺠)"],
    ["申请⻔槛低", "不需要解释商业背景和资金来源"],
    [
      "畅游欧洲，养老度假",
      "可自由往返 27个欧洲申根国家，子女可以在⻄班牙享受免费教育",
    ],
  ],
  requirements: {
    investmentRequirement: <ReSpainInvReq />,
    projectRequirement: null,
    personalRequirement: <ReSpainPerReq />,
    dependentsRequirement: null,
    otherRequirement: null,
  },
  process: {
    steps: 5,
    duration: {
      min: 6,
      max: 8,
      unit: "个月",
    },
    details: [
      "评估签约",
      "选择购买适宜房产",
      "支付全款，完成房产注册后制作移⺠材料",
      "获得地契，将移⺠资料递交移⺠局",
      "20天获批1年投资居留签证",
    ],
  },
};

const residencePortugal: ImmigrationProgram = {
  id: 8,
  image: {
    map: portugalImgMap,
    flag: portugalImgFlag,
    background: portugalImgBackground,
  },
  country: "葡萄牙",
  countryEn: "portugal",
  continent: "欧洲",
  description:
    "投资50万欧元基金或房产，10-12个月获批，享免费医疗和教育，7天/年居住要求，5年后可申请永居。",
  immigrationType: {
    title: "投资移⺠",
    type: "居留项目",
  },
  investmentAmount: {
    set: 500000,
    optional: 0,
    above: true,
  },
  currency: {
    title: "欧元",
    symbol: "€",
  },
  countryOverview: {
    description: [
      "葡萄牙共和国(葡萄牙语:República Portuguesa;英语:The Portuguese Republic)，是一个位于欧洲⻄南部的共和制 国家。东邻同处于伊比利亚半岛的⻄班牙，葡 萄牙的⻄部和南部是大⻄洋的海岸。",
      "除了欧洲大陆的领土以外，大⻄洋的亚速群岛和⻢德拉群岛也是葡萄牙领土。",
      "葡萄牙首都里斯本以⻄的罗卡⻆是欧洲大陆的 最⻄端，葡萄牙语是2.4亿人的共同母语，也 是世界第六大语言。",
      "葡萄牙气候温和，每年拥有3000多个小时的 日照时间和850 公里壮丽的大⻄洋海滩，它全 年都是理想的度假胜地。",
    ],
    officialCurrency: "欧元",
    officialLanguage: "葡萄牙语",
    visaFree: 188,
  },
  advantages: [
    ["高性价比的准欧盟身份", "自由通行欧洲27个申根国家"],
    ["无门槛", "无商业背景，无学术背景要求，无经济来源要求，无语言要求"],
    ["居住要求低", "极低居住要求(14+14+14，平均每年7天)"],
    ["就业自由", "可以在葡萄牙自由工作和经商"],
    ["社会福利", "免费的公立医疗福利、公立教育福利"],
    [
      "新生儿'落地生'",
      "父母一方持有合法身份满一年，出生在葡萄牙的新生儿直接获得葡萄牙身份",
    ],
    ["三代移民", "一人申请，三代移⺠，子女及双方父母均可同时申请"],
  ],
  requirements: {
    investmentRequirement: <RePortugalInvReq />,
    projectRequirement: null,
    personalRequirement: <RePortugalPerReq />,
    dependentsRequirement: <RePortugalDepReq />,
    otherRequirement: null,
  },
  process: {
    steps: 12,
    duration: {
      min: 10,
      max: 12,
      unit: "个月",
    },
    details: [
      "签约提供基本信息",
      "收到法律文件包，签署及认证，委托协议",
      "律师代开设税号及银行账户",
      "转投资款和其他费用",
      "房产过户(律师在葡代办)",
      "准备双认证相关文件",
      "律师在线提交移⺠文件",
      "SEF预审批通过",
      "预约指纹录入日期",
      "办理身份签证",
      "申请人赴葡打指纹",
      "SEF预审批通过",
    ],
  },
};

const residenceSingapore: ImmigrationProgram = {
  id: 9,
  image: {
    map: singaporeImgMap,
    flag: singaporeImgFlag,
    background: singaporeImgBackground,
  },
  country: "新加坡",
  countryEn: "singapore",
  continent: "亚洲",
  description:
    "投资1000万新币设立家族办公室，9-12个月获批，享税收优惠及资产配置自由，适合高净值家庭。",
  immigrationType: {
    title: "家族办公室",
    type: "居留项目",
  },
  investmentAmount: {
    set: 10000000,
    optional: 0,
    above: false,
  },
  currency: {
    title: "新元",
    symbol: "S$",
  },
  countryOverview: {
    description: [
      "新加坡共和国(英语:Republic of Singapore)，是位于东南亚的城邦岛国、城 市国家。新加坡由新加坡岛等63个岛屿组 成，面积为728平方公里，因环境优美有花园 城市之美称。",
      "1970年代以来，新加坡经济迅速发展，被誉 为“亚洲四小⻰”之一，人均国内生产总值、人 类发展指数高居全球前列。目前，新加坡是全 球重要的炼油、贸易、物流中心，也是亚洲最 大的国际金融中心。2020年，新加坡人口逾 560万，是全球人口密度最高的国家之一，同 时，新加坡也是一个多元文化种族的社会，人 口组成以华人为多数，大多数的新加坡人都通 晓至少两种语言，分别是英语以及自己的母 语。",
    ],
    officialCurrency: "新加坡元",
    officialLanguage: "英语，华语，⻢来语，泰米尔语",
    visaFree: 194,
  },
  advantages: [
    ["⻔槛低", "无企业规模，投资背景或学历要求，无需创业和 积极运营公司。"],
    ["自由度", "自主选择海外资产配置，指定投资收益享受免税 政策。"],
    ["一劳永逸", "实现资产配置增值和全家移⺠身份配置。"],
    [
      "理想的家族办公室设立地",
      "政府扶持，透明法律政策，公 司法信托法完善，政治经济大环境稳定",
    ],
  ],
  requirements: {
    investmentRequirement: <ReSingaporeInvReq />,
    projectRequirement: null,
    personalRequirement: <ReSingaporePerReq />,
    dependentsRequirement: null,
    otherRequirement: null,
  },
  process: {
    steps: 10,
    duration: {
      min: 9,
      max: 12,
      unit: "个月",
    },
    details: [
      "评估签约",
      "KYC、背调",
      "申请材料准备",
      "提交新加坡金融管理局初审及面试",
      "注册新加坡公司以及开新加坡公户",
      "提交新加坡EP申请并获得EP",
      "提交新加坡金融局进行终审",
      "通过新加坡金融管理局终审",
      "执行投资计划",
      "获得签证",
    ],
  },
};

const passportVanuatu: ImmigrationProgram = {
  id: 10,
  image: {
    map: vanuatuImgMap,
    flag: vanuatuImgFlag,
    background: vanuatuImgBackground,
  },
  country: "瓦努阿图",
  countryEn: "vanuatu",
  continent: "大洋洲",
  description:
    "捐款8万美元，最快1个月获批护照，无居住要求，英联邦护照适合资产规划及国际通行。",
  immigrationType: {
    title: "护照",
    type: "护照项目",
  },
  investmentAmount: {
    set: 80000,
    optional: 0,
    above: true,
  },
  currency: {
    title: "美元",
    symbol: "$",
  },
  countryOverview: {
    description: [
      "瓦努阿图共和国 位于南太平洋⻄部，属美拉 尼⻄亚群岛，由83个岛屿(其中68个岛屿有 人居住)组成。最大的岛屿是桑托岛(面积 3974平方公里)，属热带海洋性气候，年均 降水量1600毫米。首都维拉港平均气温 25.3°C。",
    ],
    officialCurrency: "瓦图",
    officialLanguage: "英语、法语和比斯拉⻢语，通用 比斯拉⻢语",
    visaFree: 91,
  },
  advantages: [
    [
      "周期短",
      "市场上办理周期最快的护照，从签约到领取护 照，平均45天，最快成功案例只需一个月。",
    ],
    ["合法入籍", "大洋洲仅有的合法入籍的护照项目。"],
    [
      "含金量高的英联邦护照",
      "适用于全球资产规划、海外架 构搭建、全球自由通行、享受国际教育等需求的客户， 是一本含金量极高的英联邦护照。",
    ],
    ["一步到位", "一人申请，三代同行"],
    ["移⺠不移居", "无登陆及居住要求"],
  ],
  requirements: {
    investmentRequirement: <PaVanuatuInvReq />,
    projectRequirement: null,
    personalRequirement: <PaVanuatuPerReq />,
    dependentsRequirement: <PaVanuatuDepReq />,
    otherRequirement: null,
  },
  process: {
    steps: 7,
    duration: {
      min: 1,
      max: 2,
      unit: "个月",
    },
    details: [
      "评估签约",
      "收集材料",
      "制作材料",
      "背景调查",
      "递交材料",
      "获得批复函",
      "完成宣誓并获得护照",
    ],
  },
};

const passportSaintKitts: ImmigrationProgram = {
  id: 11,
  image: {
    map: stKittsImgMap,
    flag: stKittsImgFlag,
    background: stKittsImgBackground,
  },
  country: "圣基茨",
  countryEn: "st-kitts-and-nevis",
  continent: "美洲",
  description:
    "捐款25万美元起，6-8个月获批，无居住要求，免签156国，享税务优势及全球资产规划便利。",
  immigrationType: {
    title: "护照",
    type: "护照项目",
  },
  investmentAmount: {
    set: 250000,
    optional: 0,
    above: false,
  },
  currency: {
    title: "美元",
    symbol: "$",
  },
  countryOverview: {
    description: [
      "圣基茨和尼维斯联邦(The Federation of Saint Kitts and Nevis)，简称“圣基茨和尼维斯”，位于中美洲加勒比海地区小安的列斯群岛北部背⻛群岛，是一个由圣基茨岛和尼维斯岛组成的联邦制岛国。于1983年9月19日独立，现为英联邦成员国之一。圣基茨和尼维斯护照项目开设于1984年，是世界上最早开设 护照项目的国家。政策成熟稳定，申请条件简单。",
    ],
    officialCurrency: "东加勒比元和美元",
    officialLanguage: "英语",
    visaFree: 156,
  },
  advantages: [
    ["美洲护照", "世界上最古老合法一步到位拿护照的移⺠项 目"],
    ["要求简单", "无语言、年龄、经商经验、资产额度、资金 来源等要求"],
    ["无移⺠监", "从申请到拿护照期间无居住、无登陆要求"],
    ["税务优势", "无个人所得税、海外收入征税、资本利得税、遗产税、赠与税"],
    ["法律依据", "1984年列入国家宪法，移⺠局官网有据可查"],
    ["历史悠久", "1984开始实施，早于加拿大、澳洲等大国"],
  ],
  requirements: {
    investmentRequirement: <PaSaintKittsAndNevisInvReq />,
    projectRequirement: null,
    personalRequirement: <PaSaintKittsAndNevisPerReq />,
    dependentsRequirement: <PaSaintKittsAndNevisDepReq />,
    otherRequirement: null,
  },
  process: {
    steps: 6,
    duration: {
      min: 6,
      max: 8,
      unit: "个月",
    },
    details: [
      "评估签约",
      "收集资料",
      "资料制作",
      "资料递交",
      "获得批复涵",
      "获得护照",
    ],
  },
};

const passportAntigua: ImmigrationProgram = {
  id: 12,
  image: {
    map: antiguaImgMap,
    flag: antiguaImgFlag,
    background: antiguaImgBackground,
  },
  country: "安提瓜和巴布达",
  countryEn: "antigua-and-barbuda",
  continent: "美洲",
  description:
    "捐款23万美元起，6-8个月获批，无需居住，免签165国，三代同移，适合税务优化。",
  immigrationType: {
    title: "护照",
    type: "护照项目",
  },
  investmentAmount: {
    set: 230000,
    optional: 0,
    above: true,
  },
  currency: {
    title: "美元",
    symbol: "$",
  },
  countryOverview: {
    description: [
      "安提瓜和巴布达(Antigua and Barbuda)， 位于加勒比海小安的列斯群岛的北部。为英联 邦成员国。安提瓜和巴布达岛属于热带气候， 年平均气温27°C。年均降水量约1020毫米。 安提瓜和巴布达国⺠收入主要来源于旅游、建 筑业、离岸金融业、制造业和农业。",
    ],
    officialCurrency: "东加勒比元和美元",
    officialLanguage: "英语",
    visaFree: 165,
  },
  advantages: [
    ["美洲护照", "一步到位拿护照，全家移⺠首选"],
    ["要求简单", "无语言、年龄、经商经验、资产额度、资金来源等要求"],
    ["无移⺠监", "从申请到拿护照期间无居住、五年内登陆安提瓜1次宣誓"],
    ["税务优势", "无个人所得税、海外收入征税、资本利得税、遗产税、赠与税"],
    ["资料简单", "只需提供个人及家庭、资信证明、工作证明 文件等"],
  ],
  requirements: {
    investmentRequirement: <PaAntiguaAndBarbudaInvReq />,
    projectRequirement: null,
    personalRequirement: <PaAntiguaAndBarbudaPerReq />,
    dependentsRequirement: <PaAntiguaAndBarbudaDepReq />,
    otherRequirement: null,
  },
  process: {
    steps: 7,
    duration: {
      min: 6,
      max: 8,
      unit: "个月",
    },
    details: [
      "评估签约",
      "收集材料",
      "制作材料",
      "材料递交",
      "获得批复涵",
      "支付投资款或者捐款",
      "获得护照",
    ],
  },
};

const passportDominica: ImmigrationProgram = {
  id: 13,
  image: {
    map: dominicaImgMap,
    flag: dominicaImgFlag,
    background: dominicaImgBackground,
  },
  country: "多米尼克",
  countryEn: "dominica",
  continent: "美洲",
  description:
    "捐款20万美元起，6-8个月获批，无居住要求，免签140国，全家四代可同时移民。",
  immigrationType: {
    title: "护照",
    type: "护照项目",
  },
  investmentAmount: {
    set: 200000,
    optional: 0,
    above: true,
  },
  currency: {
    title: "美元",
    symbol: "$",
  },
  countryOverview: {
    description: [
      "多米尼克国(The Commonwealth of Dominica)是位于东加勒比海向⻛群岛东北 部的一个岛国。东临大⻄洋，⻄濒加勒比海， 南与⻢提尼克岛隔⻢提尼克海峡、北同瓜德罗 普隔多米尼克海峡相望。国土面积751平方公 里，年均气温25至32度，热带海洋气候。现 为英联邦成员国。 多米尼克投资公⺠计划始 于1993年。",
    ],
    officialCurrency: "东加勒比元和美元",
    officialLanguage: "英语",
    visaFree: 140,
  },
  advantages: [
    ["美洲护照", "一步到位拿护照，全家四代移⺠"],
    ["要求简单", "无语言、年龄、经商经验、资产额度、资金来源等要求"],
    ["无移⺠监", "从申请到拿护照期间无居住、无登陆要求"],
    ["税务优势", "无个人所得税、海外收入征税、资本利得 税、遗产税、赠与税"],
    ["政策稳定", "移⺠法案写在国家最高宪法中，稳定安全"],
    ["资料简单", "只需提供个人及家庭、资信证明、工作证明 文件等"],
  ],
  requirements: {
    investmentRequirement: <PaDominicaInvReq />,
    projectRequirement: null,
    personalRequirement: <PaDominicaPerReq />,
    dependentsRequirement: null,
    otherRequirement: null,
  },
  process: {
    steps: 7,
    duration: {
      min: 6,
      max: 8,
      unit: "个月",
    },
    details: [
      "评估签约",
      "收集材料",
      "制作材料",
      "材料递交",
      "背景调查",
      "获得批复涵",
      "获得护照及公民纸",
    ],
  },
};

const passportGrenada: ImmigrationProgram = {
  id: 14,
  image: {
    map: grenadaImgMap,
    flag: grenadaImgFlag,
    background: grenadaImgBackground,
  },
  country: "格林纳达",
  countryEn: "grenada",
  continent: "美洲",
  description:
    "捐款23.5万美元起，6-8个月获批，可申请美国E-2签证，与中国互免签证，三代同移。",
  immigrationType: {
    title: "护照",
    type: "护照项目",
  },
  investmentAmount: {
    set: 235000,
    optional: 0,
    above: false,
  },
  currency: {
    title: "美元",
    symbol: "$",
  },
  countryOverview: {
    description: [
      "格林纳达(英文:Grenada)位于东加勒比海 向⻛群岛的最南端，南距委内瑞拉海岸约160 公里。属热带海洋性气候，年平均气温 26°C。农业和旅游业是经济的基础，主要农 产品肉豆蔻产量约占世界总产量的三分之一， 仅次于印度尼⻄亚，居世界第二位。现为英联 邦成员国。格林纳达于2013年新的投资移⺠ 法案颁布，格林纳达政府为推行新经济政策， 成立国家发展基金为了促进该计划的发展。",
    ],
    officialCurrency: "美元和东加勒比元",
    officialLanguage: "英语",
    visaFree: 140,
  },
  advantages: [
    ["美洲护照", "一步到位拿护照，全家四代移⺠"],
    ["要求简单", "无语言、年龄、经商经验、资产额度、资金来源等要求"],
    ["无移⺠监", "从申请到拿护照期间无居住、无登陆要求"],
    ["税务优势", "无海外收入征税、资本利得、遗产、赠与税"],
    ["政策稳定", "移⺠法案写在国家最高宪法中，稳定安全"],
    ["资料简单", "只需个人及家庭、资信证明、工作证明等"],
    [
      "中国免签",
      "加勒比护照项目中唯一与中国互相免签的国 家，并同时可获得该国永居",
    ],
  ],
  requirements: {
    investmentRequirement: <PaGrenadaInvReq />,
    projectRequirement: null,
    personalRequirement: <PaGrenadaPerReq />,
    dependentsRequirement: <PaGrenadaDepReq />,
    otherRequirement: null,
  },
  process: {
    steps: 9,
    duration: {
      min: 6,
      max: 8,
      unit: "个月",
    },
    details: [
      "评估签约",
      "预背调，收集资料",
      "资料制作",
      "银行清算",
      "材料递交",
      "获得批复涵",
      "完成捐款",
      "确认捐款到账",
      "完成宣誓并获得护照及公民纸",
    ],
  },
};

const passportSaintLucia: ImmigrationProgram = {
  id: 15,
  image: {
    map: stLuciaImgMap,
    flag: stLuciaImgFlag,
    background: stLuciaImgBackground,
  },
  country: "圣卢⻄亚",
  countryEn: "st-lucia",
  continent: "美洲",
  description:
    "捐款24万美元，6-8个月获批，无居住要求，免签150国，适合资产规划及家庭移民。",
  immigrationType: {
    title: "护照",
    type: "护照项目",
  },
  investmentAmount: {
    set: 240000,
    optional: 0,
    above: false,
  },
  currency: {
    title: "美元",
    symbol: "$",
  },
  countryOverview: {
    description: [
      "圣卢⻄亚(英语:Saint Lucia)，位于东加勒 比海向⻛群岛中部，北邻⻢提尼克岛，⻄南邻 圣文森特岛，是小安地列斯群岛的一部分。圣 卢⻄亚是座火山岛。现为英联邦成员国。 圣 卢⻄亚投资入籍计划受2015年《投资入籍 法》第14条管辖，该法案第33章节建立的一 项特殊基金正式针对全球投资入籍申请人的投 资移⺠项目。",
    ],
    officialCurrency: "东加勒比元和美元",
    officialLanguage: "英语",
    visaFree: 150,
  },
  advantages: [
    ["美洲护照", "一步到位拿护照，全家四代移⺠"],
    ["要求简单", "无语言、年龄、经商经验、资产额度、资金来源等要求"],
    ["无移⺠监", "从申请到拿护照期间无居住、无登陆要求"],
    ["税务优势", "无个人所得税、海外收入征税、资本利得 税、遗产税、赠与税"],
    ["政策稳定", "移⺠法案写在国家最高宪法中，稳定安全"],
    ["资料简单", "只需提供个人及家庭、资信证明、工作证明 文件等"],
  ],
  requirements: {
    investmentRequirement: <PaStLuciaInvReq />,
    projectRequirement: null,
    personalRequirement: <PaStLuciaPerReq />,
    dependentsRequirement: <PaStLuciaDepReq />,
    otherRequirement: [<PaStLuciaReunionReq />],
  },
  process: {
    steps: 7,
    duration: {
      min: 6,
      max: 8,
      unit: "个月",
    },
    details: [
      "评估签约",
      "收集材料",
      "制作材料",
      "材料递交",
      "获得批复涵",
      "完成投资",
      "获得护照及公民纸",
    ],
  },
};

const passportGeorgia: ImmigrationProgram = {
  id: 16,
  image: {
    map: georgiaImgMap,
    flag: georgiaImgFlag,
    background: georgiaImgBackground,
  },
  country: "格鲁吉亚",
  countryEn: "georgia",
  continent: "美洲",
  description:
    "捐款25万欧元，6个月获批，无居住要求，免签153国，适合资产规划及家庭移民。",
  immigrationType: {
    title: "护照",
    type: "护照项目",
  },
  investmentAmount: {
    set: 250000,
    optional: 0,
    above: false,
  },
  currency: {
    title: "欧元",
    symbol: "€",
  },
  countryOverview: {
    description: [
      "格鲁吉亚（英文：Georgia）位于南高加索中西部，西邻黑海，是古丝绸之路和现代欧亚走廊必经之地，拥有3000多年的悠久历史和灿烂文化。格吉亚四季分明，气候宜人，生活便利，拥有丰富的自然资源和独特的地理景观，被誉为“上帝的后花园”。",
    ],
    officialCurrency: "拉里(Lari)",
    officialLanguage: "格鲁吉亚语",
    visaFree: 153,
  },
  advantages: [
    [
      "子女教育",
      "以国际学校成绩申请顶尖欧美名校回国参加国际生联考，轻松入读985名校",
    ],
    [
      "畅行全球",
      "全球自由出行，可办理E2自由出入美国商务出行或休闲旅游，轻松规划国际行程",
    ],
    [
      "国际投资",
      "WTO成员国，享优惠关税，开立全球帐户欧盟候选国，未来有望成为欧盟公民",
    ],
    [
      "商业潜力",
      "全球前十经济体，金融自由度高，政策亲商为经商创业提供良好环境",
    ],
    ["健康栖居", "自然景观壮丽辽阔康养宜居的理想之地"],
    ["资金安全", "可全球开户，账户私密性强、安全性高高净值人群资产分配更轻松"],
  ],
  requirements: {
    investmentRequirement: <PaGeorgiaInvReq />,
    projectRequirement: null,
    personalRequirement: <PaGeorgiaPerReq />,
    dependentsRequirement: <PaGeorgiaDepReq />,
    otherRequirement: null,
  },
  process: {
    steps: 9,
    duration: {
      min: 6,
      max: 6,
      unit: "个月",
    },
    details: [
      "评估签约",
      "收集材料",
      "制作材料",
      "背景调查",
      "完成投资",
      "材料递交",
      "获得批复涵",
      "入境录指纹 ",
      "获得护照",
    ],
  },
};

const residenceMgtJapan: ImmigrationProgram = {
  id: 17,
  image: {
    map: japanImgMap,
    flag: japanImgFlag,
    background: japanImgBackground,
  },
  country: "日本",
  countryEn: "japan-management",
  continent: "亚洲",
  description:
    "投资500万日元房产，4-8个月获批，享全民医保报销最高达90%，教育全球前十，资产配置安全可靠，10年后可申请永住。",
  immigrationType: {
    title: "经营管理签证",
    type: "居留项目",
  },
  investmentAmount: {
    set: 5000000,
    optional: 0,
    above: true,
  },
  currency: {
    title: "日圆",
    symbol: "JP¥",
  },
  countryOverview: {
    description: [
      "日本是位于东亚的岛国，由超过14,000个岛屿组成，总面积约37.8万平方公里，人口约1.24亿，是世界第11大人口国。首都圈人口超3, 500万，为全球最大都市圈。日本为议会制君主立宪国家，天皇为象征性元首，实权由国会和内阁掌握。",
      "战后日本经济高速增长，曾跃居世界第二大经济体，现为世界第四大经济体和第四大贸易国，是七大工业国成员。尽管近年面临低增长、少子化和老龄化等挑战，日本依然保持较高人类发展水平和科技制造优势。",
    ],
    officialCurrency: "日圆 (日元)",
    officialLanguage: "日语",
    visaFree: 173,
  },
  advantages: [
    [
      "申请门槛低",
      "无资金来源、学历、语言、体检要求，学历语言可作为优势加分。",
    ],
    [
      "高福利体系",
      "全民医保报销最高达90 %，教育全球前十，生育福利健全，配偶可工作，部分条件下可携带父母与佣人。",
    ],
    [
      "资产配置安全可靠",
      "投资日本不动产，市场成熟透明，法律保障完善，风险低，投资安全。",
    ],
    ["护照含金量高", "入籍后可免签173个国家和地区，含G7国家，全球通行力强。"],
    [
      "宜居宜业",
      "与中国生活习惯相近，文化融合无障碍，距离近、交通便捷，是离家最近的发达国家。",
    ],
  ],
  requirements: {
    investmentRequirement: <ReJapanInvReq_Mgt />,
    projectRequirement: null,
    personalRequirement: <ReJapanPerReq_Mgt />,
    dependentsRequirement: null,
    otherRequirement: [<ReJapanOtherReq_Mgt />],
  },
  process: {
    steps: 8,
    duration: {
      min: 4,
      max: 8,
      unit: "个月",
    },
    details: [
      "评估签约",
      "预背调，收集资料",
      "完成注册公司",
      "资料制作",
      "材料递交申请交付在留资格证书",
      "获得在留资格认定书",
      "所在国日本驻华使馆申请入境签",
      "入境换取在留卡",
    ],
  },
};

const residenceIndividualJapan: ImmigrationProgram = {
  id: 18,
  image: {
    map: japanImgMap,
    flag: japanImgFlag,
    background: japanImgBackground,
  },
  country: "日本",
  countryEn: "japan-individual",
  continent: "亚洲",
  description:
    "投资500万日元房产，4-8个月获批，享全民医保报销最高达90%，教育全球前十，资产配置安全可靠，最快1年后可申请永住。",
  immigrationType: {
    title: "高级人才签证",
    type: "居留项目",
  },
  investmentAmount: {
    set: 5000000,
    optional: 0,
    above: true,
  },
  currency: {
    title: "日圆",
    symbol: "JP¥",
  },
  countryOverview: {
    description: [
      "日本是位于东亚的岛国，由超过14,000个岛屿组成，总面积约37.8万平方公里，人口约1.24亿，是世界第11大人口国。首都圈人口超3, 500万，为全球最大都市圈。日本为议会制君主立宪国家，天皇为象征性元首，实权由国会和内阁掌握。",
      "战后日本经济高速增长，曾跃居世界第二大经济体，现为世界第四大经济体和第四大贸易国，是七大工业国成员。尽管近年面临低增长、少子化和老龄化等挑战，日本依然保持较高人类发展水平和科技制造优势。",
    ],
    officialCurrency: "日圆 (日元)",
    officialLanguage: "日语",
    visaFree: 173,
  },
  advantages: [
    [
      "申请门槛低",
      "无资金来源、学历、语言、体检要求，学历语言可作为优势加分。",
    ],
    [
      "高福利体系",
      "全民医保报销最高达90 %，教育全球前十，生育福利健全，配偶可工作，部分条件下可携带父母与佣人。",
    ],
    [
      "资产配置安全可靠",
      "投资日本不动产，市场成熟透明，法律保障完善，风险低，投资安全。",
    ],
    ["护照含金量高", "入籍后可免签173个国家和地区，含G7国家，全球通行力强。"],
    [
      "宜居宜业",
      "与中国生活习惯相近，文化融合无障碍，距离近、交通便捷，是离家最近的发达国家。",
    ],
  ],
  requirements: {
    companyRequirement: <ReJapanInvReq_Individual />,
    projectRequirement: null,
    personalRequirement: <ReJapanPerReq_Individual />,
    dependentsRequirement: null,
    otherRequirement: [<ReJapanOtherReq_Individual />],
  },
  process: {
    steps: 8,
    duration: {
      min: 4,
      max: 8,
      unit: "个月",
    },
    details: [
      "评估签约",
      "预背调，收集材料",
      "完成注册公司",
      "资料制作",
      "材料递交",
      "获得批复涵",
      "所在国日本驻华使馆申请入境签",
      "入境换取在留卡",
    ],
  },
};

const residenceCyprus: ImmigrationProgram = {
  id: 21,
  image: {
    map: cyprusImgMap,
    flag: cyprusImgFlag,
    background: cyprusImgBackground,
  },
  country: "塞浦路斯",
  countryEn: "cyprus",
  continent: "欧洲",
  description: "房产30万欧元，2-4个月获批，免签169国，适合资产规划及家庭移民。",
  immigrationType: {
    title: "投资移⺠",
    type: "居留项目",
  },
  investmentAmount: {
    set: 300000,
    optional: 0,
    above: false,
  },
  currency: {
    title: "欧元",
    symbol: "€",
  },
  countryOverview: {
    description: [
      "塞浦路斯共和国（希腊语：Κυπριακή Δημοκρατία，罗马化：Kypriakí Dimokratía；土耳其语：Kıbrıs Cumhuriyeti），通称塞浦路斯（希腊语：Κύπρος；土耳其语：Kıbrıs），是位于欧亚大陆交汇处地中海东部的一个岛国，面积9,251平方公里。",
      "虽然塞浦路斯在地理分类上位于西亚，但自古与欧洲的人文和贸易往来关系密切，自我认同为欧洲国家，塞浦路斯共和国于2004年5月1日正式加入欧盟成为欧洲联盟成员国。",
    ],
    officialCurrency: "欧元",
    officialLanguage: "希腊语、土耳其语",
    visaFree: 169,
  },
  advantages: [
    [
      "永居优势",
      "欧盟成员国永久居留身份，终身有效，无语言要求，涵盖配偶与子女，仅需每两年到访一次",
    ],

    [
      "优质生活",
      "全球最佳移居地区第五位，全年300多天光照，气候宜人，蓝旗海滩数量居欧盟首位",
    ],

    [
      "安全保障",
      "世界最安全国家排名第五，欧洲最低犯罪率，欧盟统计局认证的最安全国家",
    ],

    [
      "税收优惠",
      "零遗产税、零财产税、零转让费，企业税仅12.5%，股息利息免税，国际投资环境优渥",
    ],

    [
      "房地产繁荣",
      "房产销售自低谷反弹增长175%以上，外籍购房占比40%+，投资与生活兼顾",
    ],

    [
      "帕福斯优势",
      "外国买家首选城市，风景优美，交通便利，设施完善，拥有四大高尔夫球场和便捷国际机场",
    ],
  ],
  requirements: {
    investmentRequirement: <ReCyprusInvReq />,
    projectRequirement: null,
    personalRequirement: <ReCyprusPerReq />,
    dependentsRequirement: <ReCyprusDepReq />,
    otherRequirement: null,
  },
  process: {
    steps: 9,
    duration: {
      min: 2,
      max: 4,
      unit: "个月",
    },
    details: [
      "评估签约",
      "收集材料",
      "制作材料",
      "背景调查",
      "完成投资",
      "材料递交",
      "获得批复涵",
      "入境取得实物许可证和数字身份证",
      "每两年入境一次",
    ],
  },
};

const passportNauru: ImmigrationProgram = {
  id: 19,
  image: {
    map: nauruImgMap,
    flag: nauruImgFlag,
    background: nauruImgBackground,
  },
  country: "瑙鲁",
  countryEn: "nauru",
  continent: "大洋洲",
  description:
    "捐款10.5万美元，6个月获批，无居住要求，免签90国，适合资产规划及家庭移民。",
  immigrationType: {
    title: "护照",
    type: "护照项目",
  },
  investmentAmount: {
    set: 105000,
    optional: 0,
    above: true,
  },
  currency: {
    title: "澳元",
    symbol: "AUD",
  },
  countryOverview: {
    description: [
      "瑙鲁（英文：The Republic of Nauru), 英联邦成员国之一，位于中太平洋的岛国，行政管理中心亚伦。本国人口多为密克罗尼西亚人种，其余为其他太平洋岛国人、华人、菲律宾人和欧洲人后裔。",
    ],
    officialCurrency: "澳元（AUD）",
    officialLanguage: "英语",
    visaFree: 90,
  },
  advantages: [
    ["性价比高", "目前市场上投资金额最低的投资入籍计划之一"],
    ["办理快速", "递交申请后3 - 4个月获批，先审批后捐款"],
    ["无需登陆", "申请和护照续签无需登陆和居住"],
    ["一步到位", "一人申请，家庭四代可随行移民"],
    ["税务优势", "低个人所得税，无全球征税，无资本所得 / 遗产税等"],
    ["教育规划", "孩子以国际生身份，可免笔试读内地名校 / 国际学校"],
    ["允许双国籍", "瑙鲁护照允许双国籍，无需放弃原国籍身份"],
    ["便利出行", "免签英国、中国澳门、中国香港、新加坡、阿联酋等约90个国家"],
  ],
  requirements: {
    investmentRequirement: <PaNauruInvReq />,
    projectRequirement: null,
    personalRequirement: <PaNauruPerReq />,
    dependentsRequirement: <PaNauruDepReq />,
    otherRequirement: null,
  },
  process: {
    steps: 9,
    duration: {
      min: 6,
      max: 6,
      unit: "个月",
    },
    details: [
      "评估签约",
      "收集材料",
      "制作材料",
      "背景调查",
      "完成投资",
      "材料递交",
      "参加面试",
      "获得批复涵",
      "完成宣誓并获得护照",
    ],
  },
};

const passportElSalvador: ImmigrationProgram = {
  id: 20,
  image: {
    map: elSalvadorImgMap,
    flag: elSalvadorImgFlag,
    background: elSalvadorImgBackground,
  },
  country: "萨尔瓦多",
  countryEn: "el-salvador",
  continent: "中美洲",
  description:
    "购买国债37.5万美元，6个月获批，申请门槛低，支付方式灵活，免签133国，适合资产规划及家庭移民。",
  immigrationType: {
    title: "护照",
    type: "护照项目",
  },
  investmentAmount: {
    set: 375000,
    optional: 0,
    above: false,
  },
  currency: {
    title: "美元",
    symbol: "$",
  },
  countryOverview: {
    description: [
      "萨尔瓦多（英文：El Salvador）位于中美洲北部，热带雨林气候，全年温度15℃-29℃，山地凉爽，洼地湿热。1524年沦为西班牙殖民地。2021成为全球首个比特币合法化的国家。",
      "比特币作为法定货币、发行数字国债、建设比特币未来城，是萨尔瓦多发展区块链数字经济的几个重要步骤。依山傍海，热带雨林环绕，比特币未来城将以比特币作为价值基础、区块链技术，Web3和AI支撑社会治理体系，以建设一个现代、宜居、充满未来气息的高科技梦幻城市。投资萨尔瓦多美元数字国债，移居崛起的希望之地，抓住时代机遇，积极参与全球未来梦幻家园建设。",
    ],
    officialCurrency: "美元、比特币",
    officialLanguage: "西班牙语",
    visaFree: 133,
  },
  advantages: [
    ["极速拿护照", "最快一周获批，打款购买国债后1–3个月获得护照，办理周期短。"],
    ["申请门槛低", "无需资金来源证明、无犯罪记录，材料简单，无繁琐审核流程。"],
    ["支付方式灵活", "可用银行转账或比特币等虚拟货币购买国债，便捷高效。"],
    ["免签广泛", "持护照可免签133国，涵盖欧盟、日韩、港澳，出行无忧。"],
    [
      "税务优势明显",
      "非CRS国家，无全球征税，利息免税，离岸业务免税，税负极低。",
    ],
    [
      "成本低回报高",
      "国债一年后可转让，净花费低于5万美元，7.5 % 年利息自动结算，适合全家规划。",
    ],
  ],
  requirements: {
    investmentRequirement: <PaElSalvadorInvReq />,
    projectRequirement: null,
    personalRequirement: <PaElSalvadorPerReq />,
    dependentsRequirement: <PaElSalvadorDepReq />,
    otherRequirement: [<PaElSalvadorOtherReq />],
  },
  process: {
    steps: 9,
    duration: {
      min: 6,
      max: 6,
      unit: "个月",
    },
    details: [
      "评估签约",
      "收集材料",
      "制作材料",
      "背景调查",
      "完成投资",
      "材料递交",
      "获得批复涵",
      "入境录指纹 ",
      "获得护照",
    ],
  },
};

const residencePanama: ImmigrationProgram = {
  id: 22,
  image: {
    map: panamaImgMap,
    flag: panamaImgFlag,
    background: panamaImgBackground,
  },
  country: "巴拿马",
  countryEn: "panama",
  continent: "北美洲",
  description:
    "投资购买巴拿⻢不低于300,000美金的单套房产，3个月获批，申请门槛低，免签141国，适合资产规划及家庭移民。",
  immigrationType: {
    title: "投资移⺠",
    type: "居留项目",
  },
  investmentAmount: {
    set: 300000,
    optional: 0,
    above: true,
  },
  currency: {
    title: "美元",
    symbol: "$",
  },
  countryOverview: {
    description: [
      "巴拿⻢共和国(⻄班牙语:República de Panamá)，通称巴拿⻢(⻄班牙语: Panamá)，是中美洲最南部的国家，国土面 积7.55万平方公里，人口436万。",
      "连接大⻄洋及太平洋的巴拿⻢运河位于国家的中央，划分了南北美洲，拥有重要的战略与经济地位。",
    ],
    officialCurrency: "巴波亚或美元(PAB或USD",
    officialLanguage: "⻄班牙语",
    visaFree: 141,
  },
  advantages: [
    [
      "超低⻔槛",
      "投资30万美元起，无资金来源、学历、语言 等要求，30个工作日即可获批永居。",
    ],
    ["自由灵活", "无移⺠监，仅需每两年登陆一次，无居住时 ⻓限制。"],
    ["全家三代", "可携带配偶、父母及25岁以下子女，全家共 享身份与福利。"],
    ["教育规划", "享当地优质教育资源，华侨生政策优惠，可 轻松衔接美加名校。"],
    ["经贸枢纽", "中美洲金融中心，美元自由流通，科隆自贸 区享关税优惠。"],
    [
      "大国跳板",
      "获永居后可申请入籍，并凭护照申请美国E2 签证，通往全球更广阔发展。",
    ],
  ],
  requirements: {
    investmentRequirement: <RePanamaInvReq />,
    projectRequirement: null,
    personalRequirement: <RePanamaPerReq />,
    dependentsRequirement: <RePanamaDepReq />,
    otherRequirement: null,
  },
  process: {
    steps: 11,
    duration: {
      min: 3,
      max: 6,
      unit: "个月",
    },
    details: [
      "评估签约",
      "远程/现场考察房产",
      "签署协定协议",
      "支付定金",
      "签署正式购房合同",
      "收集资料",
      "资料制作",
      "材料递交",
      "获得批复涵",
      "入境录指纹",
      "全家获得居⺠卡",
    ],
  },
};

const residenceUk2: ImmigrationProgram = {
  id: 23,
  image: {
    map: ukImgMap,
    flag: ukImgFlag,
    background: ukImgBackground,
  },
  country: "英国",
  countryEn: "uk-global-talent",
  continent: "欧洲",
  description:
    "英国创全球人才签证（GTV）无投资要求，6-12个月获批，3年可申请永居。配偶可工作，子女享免费教育，全家享医疗福利，审批快速，适合移民英国。",
  immigrationType: {
    title: "全球人才签证",
    type: "居留项目",
  },
  investmentAmount: {
    set: 0,
    optional: 0,
    above: false,
  },
  currency: {
    title: "英镑",
    symbol: "£",
  },
  countryOverview: {
    description: [
      "大不列颠及北爱尔兰联合王国(英语:The United Kingdom of Great Britain and Northern Ireland)，简称“英国”。",
      "英国是由大不列颠岛上的英格兰、威尔士和苏格兰以及爱尔兰岛东北部的北爱尔兰以及一系列附属岛屿共同组成的一个欧洲⻄部岛国。",
      "英国是一个高度发达的资本主义国家，欧洲四大经济体之一，其国⺠拥有极高的生活水平和良好的社会保障体系。英国是全球最大的金融服务净出口国。 英国作为全球金融中心的地位短时间内仍难撼动。",
    ],
    officialCurrency: "英镑",
    officialLanguage: "英语",
    visaFree: 190,
  },
  advantages: [
    [
      "先获得项目背书再申请签证",
      "申请均需要通过英国内政部指定背书机构(Endorsing Body)进行背书支持，之后递交签证申请降低被拒签⻛险",
    ],
    ["办理周期短", "6-12个月即可获批取得签证"],
    [
      "快速申请英国永居的路径",
      "主申请人3年后可申请永居，是最快能移⺠英国的方式之一",
    ],
    ["灵活安排", "申请人可全职、也可兼职工作"],
    ["全家一起申请", "配偶签证无需工作许可，可合法工作"],
    [
      "子女教育福利",
      "18周岁以下随行子女可免费就读于公立学校，入读私立学校不受签证限制，选择范围与本地学生一致",
    ],
    [
      "全家医疗福利",
      "支付NHS移⺠医疗附加费后，可享受英国公立医疗体系，获得永居后无需支付NHS费用",
    ],
  ],
  requirements: {
    investmentRequirement: null,
    projectRequirement: <ReUkGTVProjReq />,
    personalRequirement: <ReUkGTVPerReq />,
    dependentsRequirement: <ReUkGTVDepReq />,
    otherRequirement: null,
  },
  process: {
    steps: 7,
    duration: {
      min: 6,
      max: 12,
      unit: "个月",
    },
    details: [
      "评估签约",
      "材料收集、申请材料准备",
      "材料翻译、材料整合",
      "递交背书机构、申请背书",
      "面试、拿到背书信",
      "递交移⺠局审批",
      "获得签证",
    ],
  },
};

const residenceHungary: ImmigrationProgram = {
  id: 24,
  image: {
    map: hungaryImgMap,
    flag: hungaryImgFlag,
    background: hungaryImgBackground,
  },
  country: "匈牙利",
  countryEn: "hungary",
  continent: "欧洲",
  description:
    "投资25万欧元购房，4-6个月获批，可自由通行申根国，连续居住满3年，可申请转为永久居留身份。",
  immigrationType: {
    title: "投资移民",
    type: "居留项目",
  },
  investmentAmount: {
    set: 250000,
    optional: 0,
    above: false,
  },
  currency: {
    title: "欧元",
    symbol: "€",
  },
  countryOverview: {
    description: [
      "匈牙利（匈牙利语：Magyarország，发音：[ˈmɒɟɒrorsaːɡ] ）是位于欧洲的内陆国家。根据地理分区的不同定义，匈牙利被认为处在中欧和东欧。北邻斯洛伐克，东北邻乌克兰，东和东南邻罗马尼亚，南邻塞尔维亚，西南邻克罗地亚，西邻斯洛文尼亚，西北邻奥地利。官方语言为马扎尔语，为欧洲最广泛使用的非印欧语系语言。为欧盟中等面积成员国之一。",
      "首都和最大城市为布达佩斯，其余的大城市分别有德布勒 ],",
    ],
    officialCurrency: "福林（HUF）",
    officialLanguage: "马扎尔语",
    visaFree: 172,
  },
  advantages: [
    ["法案支持，安全保障", "由国家法案支持的官方项目，合规透明，整体风险可控"],
    ["欧盟门槛最低", "投资金额较低，无语言、学历、年龄、体检或经商背景要求"],
    ["先获批后投资", "审批通过后再进行投资，有效降低资金风险"],
    [
      "长期居留权（20年）",
      "一次获批最长20年居留许可，无移民监要求，可自由工作与经商",
    ],
    ["资金监管严格", "基金由央行监管，资深基金管理人运作，持有满5年可选择退出"],
    ["免费公立教育", "子女可享受当地公立教育资源"],
    ["畅行申根区", "可自由通行29个申根国家"],
    ["转永居路径清晰", "连续居住满3年，可申请转为永久居留身份"],
  ],
  requirements: {
    investmentRequirement: null,
    projectRequirement: <ReHungaryProjReq />,
    personalRequirement: <ReHungaryPerReq />,
    dependentsRequirement: <ReHungaryDepReq />,
    otherRequirement: null,
  },
  process: {
    steps: 8,
    duration: {
      min: 4,
      max: 6,
      unit: "个月",
    },
    details: [
      "评估签约",
      "收集材料",
      "制作材料",
      "背景调查",
      "完成投资",
      "材料递交和录指纹",
      "获得批复涵",
      "全家获得长期居住卡",
    ],
  },
};

const passportSaoTome: ImmigrationProgram = {
  id: 25,
  image: {
    map: saoTomeImgMap,
    flag: saoTomeImgFlag,
    background: saoTomeImgBackground,
  },
  country: "圣多美和普林西比",
  countryEn: "sao-tome-and-principe",
  continent: "非洲",
  description:
    "投资9万美元，2-3个月获批，无居住要求，免签70国，适合资产规划及家庭移民。",
  immigrationType: {
    title: "护照",
    type: "护照项目",
  },
  investmentAmount: {
    set: 90000,
    optional: 0,
    above: true,
  },
  currency: {
    title: "美元",
    symbol: "$",
  },
  countryOverview: {
    description: [
      "圣多美和普林西比民主共和国（葡萄牙语：República Democrática de São Tomé ePríncipe），通称圣多美和普林西比（SãoTomé e Príncipe），是位于中非西部的岛国，由圣多美岛、普林西比岛和附近一些礁、屿组成。面积1,001平方公里。人口约90%居住在圣多美岛。居民主要是班图人，还有混血穆拉托人和印度人，葡萄牙语为官方语言，原为葡萄牙殖民地。1975年7月12日独立，成立民主共和国。",
    ],
    officialCurrency: "圣多美和普林西比多布拉（STD）",
    officialLanguage: "葡萄牙语",
    visaFree: 70,
  },
  advantages: [
    ["全球最低成本", "9万美元起，远低于加勒比和欧洲入籍项目"],
    ["极速 & 便利", "最快6周完成、全程线上办理、无居住/语言/面试要求"],
    ["独特优势", "CPLP成员、非洲市场入口、税收优化"],
    ["可持续潜力", "资金支持生态旅游，新兴项目，避开成熟项目风险"],
  ],
  requirements: {
    investmentRequirement: null,
    projectRequirement: <PaSaoTomeProjReq />,
    personalRequirement: <PaSaoTomePerReq />,
    dependentsRequirement: <PaSaoTomeDepReq />,
    otherRequirement: null,
  },
  process: {
    steps: 8,
    duration: {
      min: 2,
      max: 3,
      unit: "个月",
    },
    details: [
      "评估签约",
      "收集材料",
      "制作材料",
      "背景调查",
      "完成投资",
      "材料递交",
      "获得批复涵",
      "获得护照",
    ],
  },
};

export const programResidenceData = {
  "uk-innovator": residenceUk,
  "uk-global-talent": residenceUk2,
  uae: residenceUae,
  greece: residenceGreece,
  hungary: residenceHungary,
  cyprus: residenceCyprus,
  portugal: residencePortugal,
  panama: residencePanama,
  "japan-management": residenceMgtJapan,
  "japan-individual": residenceIndividualJapan,
  malta: residenceMalta,
  spain: residenceSpain,
  singapore: residenceSingapore,
};

export const programPassportData = {
  malta: passportMalta,
  turkey: passportTurkey,
  "st-kitts-and-nevis": passportSaintKitts,
  dominica: passportDominica,
  "antigua-and-barbuda": passportAntigua,
  grenada: passportGrenada,
  "st-lucia": passportSaintLucia,
  nauru: passportNauru,
  georgia: passportGeorgia,
  "sao-tome-and-principe": passportSaoTome,
  vanuatu: passportVanuatu,
  // "el-salvador": passportElSalvador,
};
